import { inject } from 'mobx-react';
import { TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { ViewLarge, Viewport } from '@shared-ui/viewport-context';

import { useViewTrackerContext } from 'src/common/stores/contexts/viewTracker';

import { UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

import { MapPreview } from './map';

export const MapView: React.FunctionComponent<TemplateComponentProps> = inject('searchResults')(() => {
  const viewTracker = useViewTrackerContext();
  const tracker = useClickstreamAnalytics();

  return (
    <Viewport>
      <ViewLarge>
        <UitkLayoutGridItem colSpan={1} rowStart={1} colStart={5} id="mapViewColumn">
          <UitkSpacing padding={{ block: 'three' }}>
            <section data-stid="desktop-sidebar">
              <MapPreview viewTracker={viewTracker} tracker={tracker} />
            </section>
          </UitkSpacing>
        </UitkLayoutGridItem>
      </ViewLarge>
    </Viewport>
  );
});

MapView.displayName = 'MapView';
